import type { RateCard } from "./types";

/**
 * Fallback rate card for India (IN) market.
 *
 * Source: Meta Cloud API Pricing Matrix, effective September 2026 & October 1, 2026.
 * All rates in INR excluding 18% GST.
 *
 * IMPORTANT: This static card is used ONLY when the server `/api/billing/whatsapp/rate-card`
 * endpoint is unreachable or during offline rendering.
 */
export const FALLBACK_RATE_CARD: RateCard = {
  currency: "INR",
  gstRate: 0.18,
  market: "IN",
  timezone: "Asia/Kolkata",
  isFallback: true,
  versions: [
    {
      effectiveFrom: "2024-06-01",
      rates: {
        marketing: 0.8631,
        utility: 0.115,
        authentication: 0.115,
        service: 0,
        authentication_international: 2.4971,
      },
      serviceFreeTierPerNumber: 1000,
      utilityFreeInsideCsw: true,
    },
    {
      effectiveFrom: "2026-10-01",
      rates: {
        marketing: 0.8631,
        utility: 0.115,
        authentication: 0.115,
        service: 0.115,
        authentication_international: 2.4971,
      },
      serviceFreeTierPerNumber: 1000,
      utilityFreeInsideCsw: false,
    },
  ],
};
